import React from "react"
import PropTypes from "prop-types"
import {
  reservationTitle,
  reservationSubContainer,
  reservationChoiceTypeContainer,
  reservationCheckbox,
  reservationLoadingWrapper,
  reservationLoadingSpinner,
  checkIcon,
  spanContainer,
} from "./reservation-part-1.module.scss"
import {
  ReservationSubContainer,
  ReservationTitle,
  ReservationInputType,
} from "../reservation-styled.js"
import loadingGif from "../../../images/loading.gif"

export const ReservationPart1 = ({
  sortedTypesReservationData,
  changeType,
  typeChoisi,
}) => {
  return (
    <ReservationSubContainer className={reservationSubContainer}>
      <ReservationTitle className={reservationTitle} id={"rdv_part1_title"}>
        Choix du type de réservation
      </ReservationTitle>
      <div
        className={reservationChoiceTypeContainer}
        aria-labelledby={"rdv_part1_title"}
        role={"radiogroup"}
      >
        {!sortedTypesReservationData.length && (
          <div className={reservationLoadingWrapper}>
            <img
              alt="loading gif"
              src={loadingGif}
              className={reservationLoadingSpinner}
            />
            <span>Chargement des données...</span>
          </div>
        )}
        {sortedTypesReservationData &&
          Object.keys(sortedTypesReservationData).map((key, index) => (
            <div key={index}>
              <label
                htmlFor={sortedTypesReservationData[key].id}
                tabIndex={0}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    changeType(sortedTypesReservationData[key].id)
                  }
                }}
              >
                <ReservationInputType
                  type="radio"
                  className={reservationCheckbox}
                  value={sortedTypesReservationData[key].id}
                  checked={
                    parseInt(sortedTypesReservationData[key].id) ===
                    parseInt(typeChoisi)
                  }
                  name="choixType"
                  id={sortedTypesReservationData[key].id}
                  onClick={() => changeType(sortedTypesReservationData[key].id)}
                  tabIndex="-1"
                />{" "}
                <div className={spanContainer}>
                  <span className={checkIcon} aria-hidden={true}></span>
                  <span> {sortedTypesReservationData[key].libelle}</span>
                </div>
              </label>
            </div>
          ))}
      </div>
    </ReservationSubContainer>
  )
}

ReservationPart1.propTypes = {
  sortedTypesReservationData: PropTypes.array,
  changeType: PropTypes.func,
  typeChoisi: PropTypes.string,
}
